import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { BtnInPhieuThuChi } from "./ChucNang/InPhieuThuChi/BtnInPhieuThuChi";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnSuaThuChiHopDong } from "./ThemSua/BtnSuaThuChiHopDong";
import { BtnDaDoc } from "./BtnDaDoc";
import { BtnChiTietPhiHangKy } from "./ChiTietPhi/BtnChiTietPhiHangKy";
import { BtnChiTietPhiKhac } from "./ChiTietPhi/BtnChiTietPhiKhac";
import { catChuoi } from "utils/stringExtension";
import ThuChiHopDongApi from "../../../service/thuChiHopDongApi";
export const ContentTable = ({
  listQuanLyThuChiHopDong,
  daDoc,
  inPhieuChi,
  inPhieuThu,
  suaPhieu,
  xoaPhieu,
  isHoaHongTraGop,
  showPhiKho,
  isDuDungPhiPhatDongLaiTatToan,
  isSuDungPhiPhatDongLaiCham,
  SuDungTatToanSom,
  isWinmoney,
  batHinhThucThanhToan,
}) => {
  const listQuanLyThuChiHopDongFull = useSelector(
    (state) => state.listQuanLyThuChiHopDongFull,
  );

  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong,
  );

  const [changeState, setChangState] = useState(false);
  const [changeStateID, setChangStateID] = useState(0);
  const checkDaDoc = (thuchiId, item, index) => () => {
    let isDoc = !item.IsReaded;
    //changeState = isDoc;
    ThuChiHopDongApi.checkDaDoc(thuchiId, isDoc ? 1 : 0).then((response) => {
      //dispatch(getListQuanLyThuChiHopDong(dataSearch));
      listQuanLyThuChiHopDong[index].IsReaded = isDoc;
      setChangState(isDoc);
      setChangStateID(thuchiId);
    });
  };

  return listQuanLyThuChiHopDong.map((item, index) => (
    <div className="custom-table-row" style={{ border: "none" }}>
      <div className="custom-table-cell-v2 username-cell flex-basis-5 flex-mobile-5 disk-m5obile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          {/* <p className="text-center">{item.IndexId}</p> */}
          <p className="text-center">
            {index + 1 + (dataSearch.pageIndex - 1) * dataSearch.pageSize}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-8 flex-mobile-10 center-flex">
        <span className="mobile-column-name">Ngày giao dịch</span>
        <div className="center-wrapper color7">
          <p className="text-center">{getDate(item.Time)}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-8 flex-mobile-12">
        <span className="mobile-column-name">Nhân viên</span>
        <div className="center-wrapper color7">
          <p title={item.userFullName}>{catChuoi(item.userFullName)}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-12 center-flex">
        <span className="mobile-column-name">Mã Hợp đồng</span>
        <div>
          <p className="center-wrapper btn-link">
            <BtnChiTietHopDong item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-12">
        <span className="mobile-column-name ">Tên khách hàng</span>
        <div className="center-wrapper color7 word-break">
          <p>{item.Name}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-10 flex-mobile-10">
        <span className="mobile-column-name ">CMND</span>
        <div className="center-wrapper color7">
          <p>{item.Cmt}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-6 flex-mobile-12">
        <span className="mobile-column-name">Loại</span>
        <div className="center-wrapper color7">{item.TypeName}</div>
      </div>
      {batHinhThucThanhToan && (
        <div className="custom-table-cell-v2 flex-basis-8 flex-mobile-12 hidden-mobile-main">
          <div className="center-wrapper color7">
            {item.HinhThucThanhToan === 1 ? "Chuyển khoản" : "Tiền mặt"}
          </div>
        </div>
      )}

      <div className="custom-table-cell-v2 flex-basis-10 flex-mobile-15">
        <span className="mobile-column-name">Thu</span>
        <div className="center-wrapper ">
          {item.Value > 0 ? (
            <p className=" text-right color-xanh-bold">
              {formatNumber(item.Value)}
            </p>
          ) : (
            <p className=" text-right color-xanh-bold">0</p>
          )}
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-10 flex-mobile-15">
        <span className="mobile-column-name">Chi</span>
        <div className="center-wrapper ">
          {item.Value < 0 ? (
            <p className=" text-right color-do-bold">
              {formatNumber(item.Value)}
            </p>
          ) : (
            <p className=" text-right color-do-bold">0</p>
          )}
        </div>
      </div>
      {(listQuanLyThuChiHopDongFull.IsPhiKho === 1 ||
        listQuanLyThuChiHopDongFull.TotalPhiKho > 0) && (
        <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
          <span className="mobile-column-name">Phí kho</span>
          <div className="center-wrapper color7">
            <p className=" text-right color-xanh-bold">
              {formatNumber(item.PhiKho)}
            </p>
          </div>
        </div>
      )}

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Phí khác</span>
        <div className="center-wrapper color7">
          <p className=" text-right color-xanh-bold">
            <BtnChiTietPhiKhac item={item} />
          </p>
        </div>
      </div>
      {(isSuDungPhiPhatDongLaiCham ||
        isDuDungPhiPhatDongLaiTatToan ||
        isWinmoney) && (
        <>
          <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
            <span className="mobile-column-name">Phạt chậm đóng lãi</span>
            <div className="center-wrapper color7">
              <p className=" text-right color-xanh-bold">
                {formatNumber(
                  isDuDungPhiPhatDongLaiTatToan
                    ? item.PhiPhatDongLai
                    : item.PhiDongLaiCham,
                )}
              </p>
            </div>
          </div>
        </>
      )}
      {(isDuDungPhiPhatDongLaiTatToan || SuDungTatToanSom) && (
        <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
          <span className="mobile-column-name">Phạt tất toán sớm</span>
          <div className="center-wrapper color7">
            <p className="text-right">{formatNumber(item.PhiPhatTatToan)}</p>
          </div>
        </div>
      )}
      {(listQuanLyThuChiHopDongFull.IsHoaHongTraGop !== "0" ||
        listQuanLyThuChiHopDongFull.TotalPhiPhat > 0) && (
        <>
          <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
            <span className="mobile-column-name">Phí phạt</span>
            <div className="center-wrapper color7">
              <p className=" text-right">{formatNumber(item.Amercement)}</p>
            </div>
          </div>
          <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
            <span className="mobile-column-name">Phí hoa hồng</span>
            <div className="center-wrapper color7">
              <p className="  text-right">
                {formatNumber(item.PhiHoaHongTraGop)}
              </p>
            </div>
          </div>
        </>
      )}

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Tiền gốc</span>
        <div className="center-wrapper ">
          <p className=" text-right color-cam-bold">
            {formatNumber(item.ValueGoc)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Tiền lãi</span>
        <div className="center-wrapper">
          <p className="text-right color-xanh-bold">
            {formatNumber(item.ValueLai)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Các loại phí</span>
        <div className="center-wrapper ">
          <p className="text-right color-do-bold">
            <BtnChiTietPhiHangKy item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-8 action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter" style={{ marginLeft: "5px" }}>
            {daDoc && (
              <div
                className="text-center"
                style={{ cursor: "pointer", marginRight: "10px" }}
              >
                <img
                  src={
                    (
                      item.ThuChiID === changeStateID
                        ? changeState
                        : item.IsReaded
                    )
                      ? "/app-assets/images/icon-da-xem-v2.png"
                      : "/app-assets/images/icon-chua-xem-v2.png"
                  }
                  alt="Trạng thái đã xem"
                  onClick={() => {
                    checkDaDoc(item.ThuChiID, item, index)();
                  }}
                  style={{
                    cursor: "pointer",
                    zIndex: 10,
                    position: "relative",
                    width: "20px",
                  }}
                />
              </div>
            )}

            {/* Phiếu số tiền 0 và là thu lãi (1) / lãi quá hạn (25) thì không cho sửa */}
            {suaPhieu &&
              !(item.ValueThuChi == 0 && (item.Type == 1 || item.Type == 25)) &&
              item.isEdit && (
                // <a href={() => false}>
                //   <PopoversBootrap
                //     contentText="Sửa phiếu"
                //     trigger={["hover", "focus"]}
                //     placement={"top"}
                //   >
                //     <i className="mdi mdi-pencil-circle"></i>
                //   </PopoversBootrap>
                // </a>
                <BtnSuaThuChiHopDong
                  item={item}
                  isHoaHongTraGop={isHoaHongTraGop}
                  isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
                  isSuDungPhiPhatDongLaiCham={isSuDungPhiPhatDongLaiCham}
                  batHinhThucThanhToan={batHinhThucThanhToan}
                />
              )}

            <BtnInPhieuThuChi
              item={item}
              inPhieuChi={inPhieuChi}
              inPhieuThu={inPhieuThu}
            />
            {xoaPhieu &&
              item.Type != 24 &&
              item.Type != 2 &&
              item.Type != 4 && <BtnXoa item={item} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
